const LogLevels = {
    ANNOUNCE:'ANNOUNCE',
    ERROR:'ERROR',
    INFO:'INFO',
    DEBUG:'DEBUG'
}
export default LogLevels;
